<template>
  <v-app class="main-app">
    <router-view></router-view>
  </v-app>
</template>

<script>
export default {
  name: "App",

  data: () => ({
    //
  }),
  methods: {
    salir() {
      window.location.href = "https://www.tokiaplay.com";
    },
  },
};
</script>
<style scoped>
.text-center {
  text-align: center;
}
.subtitle {
  color: white;
  margin-top: 1rem;
}
</style>
